import type { CustomerAccount } from '../../types'
import type { ShopMessageKey } from '../../../i18n'
import { CustomerAreaSurfaceCard } from '../customer-area'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

type CustomerProfileAccountInfoCardProps = {
  account: CustomerAccount
  t: TranslateFn
}

export const CustomerProfileAccountInfoCard = ({ account, t }: CustomerProfileAccountInfoCardProps) => (
  <CustomerAreaSurfaceCard title={t('customer.profile.accountInfoTitle')}>
    <dl className="grid gap-3 text-sm sm:grid-cols-2">
      <div className="rounded-2xl border border-(--color-border-default) bg-(--color-bg-surface-muted) px-4 py-3">
        <dt className="text-xs uppercase tracking-wide text-(--color-text-muted)">{t('customer.dashboard.username')}</dt>
        <dd className="mt-1 font-semibold text-(--color-text-primary)">{account.username}</dd>
      </div>
      <div className="rounded-2xl border border-(--color-border-default) bg-(--color-bg-surface-muted) px-4 py-3">
        <dt className="text-xs uppercase tracking-wide text-(--color-text-muted)">{t('customer.profile.accountId')}</dt>
        <dd className="mt-1 break-all font-semibold text-(--color-text-primary)">{account.id}</dd>
      </div>
    </dl>
  </CustomerAreaSurfaceCard>
)
